<template>
  <div class="main-content">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

.main-content {
  width: 100%;
  height: 100%;
}

html,
body {
  width: 100%;
  height: 100%;
  /*min-width: 1920px;*/
  /*min-height: 1080px;*/
  background: #f2f2f2;
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue